import { useState } from "react";
import Header from "../../components/Header";
import ModalConfirmLogout from "../../components/ModalConfirmLogout";
// import GameList from "../../components/GameList";
import GameList from "../../components/GameListV2";

import "./HomePage.css";
import BackgroundVideo from "components/BackgroundVideo";

const HomePage = () => {
  const [isShowLogout, setIsShowLogout] = useState(false);

  return (
    <div className="home-page">
      <BackgroundVideo />
      <Header setIsShowLogout={() => setIsShowLogout(true)} />
      <GameList />
      <ModalConfirmLogout
        isShowLogout={isShowLogout}
        setIsShowLogout={() => {
          setIsShowLogout(false);
        }}
      />
    </div>
  );
};

export default HomePage;
